
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/settings/roles",
      function () {
        return require("private-next-pages/[company]/settings/roles.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company]/settings/roles"])
      });
    }
  